import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Grid, Modal, Stack, styled } from '@mui/material';
import { FC } from 'react';
import { Item, WsButton, WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';
export interface AttachmentWarningDialogProps {
  openDialog: boolean;
  closeDialog(): void;
}
const ModalBox = styled(Box)({
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
const AttachmentWarningDialog: FC<AttachmentWarningDialogProps> = ({ openDialog, closeDialog }) => (
  <Modal open={openDialog} onClose={closeDialog}>
    <ModalBox borderRadius={1.5} bgcolor={WsColors.White} p={1} height={280} width={550}>
      <Box padding={8}>
        <Stack justifyContent="center" direction="row">
          <WarningAmberIcon
            sx={{ width: '40px', height: '40px', fill: WsColors.Red300, cursor: 'pointer' }}
          />
        </Stack>
        <Grid container>
          <Grid direction="row" item>
            <Item>
              <WsTypography display="inline" variant={WsTypoVariants.TITLE}>
                Forwarding this email will not forward Attachments. Please add them once again.
              </WsTypography>
            </Item>
          </Grid>
        </Grid>
        <Stack marginTop={1} spacing={2} justifyContent="center" direction="row">
          <WsButton size="medium" variant="contained" onClick={closeDialog}>
            Confirm
          </WsButton>
        </Stack>
      </Box>
    </ModalBox>
  </Modal>
);

export default AttachmentWarningDialog;
